const desktopQuery = window.matchMedia('(min-width: 750px)');

function connectProductColumnScroll(root = document) {
  const productGrids = root.querySelectorAll('.product-information__grid');

  productGrids.forEach((productGrid) => {
    if (productGrid.dataset.sfColumnScrollConnected === 'true') return;

    const mediaColumn = productGrid.querySelector('.product-information__media');
    const detailsColumn = productGrid.querySelector('.product-details.sticky-content--desktop');

    if (!mediaColumn || !detailsColumn) return;

    productGrid.dataset.sfColumnScrollConnected = 'true';

    mediaColumn.addEventListener(
      'wheel',
      (event) => {
        if (!desktopQuery.matches || event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        const detailsMaxScroll = detailsColumn.scrollHeight - detailsColumn.clientHeight;
        if (detailsMaxScroll <= 1) return;

        const mediaBounds = mediaColumn.getBoundingClientRect();
        const detailsTop = Number.parseFloat(getComputedStyle(detailsColumn).top) || 0;
        const scrollingDown = event.deltaY > 0;
        const mediaReachedBottom = mediaBounds.bottom <= window.innerHeight + 1;
        const mediaReachedTop = mediaBounds.top >= detailsTop - 1;
        const detailsCanScrollDown = detailsColumn.scrollTop < detailsMaxScroll - 1;
        const detailsCanScrollUp = detailsColumn.scrollTop > 1;

        if (
          (scrollingDown && mediaReachedBottom && detailsCanScrollDown) ||
          (!scrollingDown && mediaReachedTop && detailsCanScrollUp)
        ) {
          event.preventDefault();
          detailsColumn.scrollBy({ top: event.deltaY, behavior: 'auto' });
        }
      },
      { passive: false }
    );
  });
}

connectProductColumnScroll();

document.addEventListener('shopify:section:load', (event) => {
  connectProductColumnScroll(event.target);
});
